// extracted by mini-css-extract-plugin
module.exports = {"relatedContentSection":"Article_relatedContentSection__p0EGV"};